export default function updateFaviconLink(fileId) {
  if (fileId) {
    const faviconUrl = fileId
      ? `${import.meta.env.VITE_FILE_URL}/${fileId}`
      : './static/logo.svg';

    var link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = faviconUrl;
  }
}
